/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{asinClamped as t}from"../../core/mathUtils.js";import{l as o,i as s}from"../../chunks/vec32.js";function n(n,a){const c=o(n),i=t(n[2]/c),r=Math.atan2(n[1]/c,n[0]/c);return s(a,c,i,r),a}function a(t,o){const n=t[0],a=t[1],c=t[2],i=Math.cos(a);s(o,n*i*Math.cos(c),n*i*Math.sin(c),n*Math.sin(a))}export{n as cartesianToSpherical,a as sphericalToCartesian};
